import React, { useEffect, useMemo, useState } from 'react';
import tracker from 'lib/tracker';
import Main from 'ripple/Containers/Main';
import { get, truncate } from 'lodash';
import Divider from '@mui/material/Divider';
import strip from 'strip';
import Avatar from '@mui/material/Avatar';
import { useMediaQuery } from 'react-responsive';
import Image from 'components/Image';
import avatarSource from 'assets/avatar.jpg';
import { Button, Typography } from '@mui/material';
import SmalliconsHP3 from 'assets/Small-icons-HP3.png';
import SmallIconsCB3 from 'assets/Small-icons-CB3.png';
import rsbg from 'assets/Ripplelight1.png';
import rsbg1 from 'assets/Ripplelight2.png';
import appadd from 'assets/AppAdd.png';
import Link from 'found/lib/Link';
import pfb from 'assets/pfb.png';
import useIsMobile from 'lib/useIsMobile';
import LoadBlur from 'components/LoadBlur';
import { useApolloClient, useLazyQuery, useQuery } from '@apollo/client';
import CredList from './CredList';
import DashboardListWalletFadeout from './FadeOutVallet';
import { GET_DASHBOARD_INFO } from '../../schema/apolloQueries/dashboardQueries';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../utils/helper';

const pageSize = 20;

const styles = {
  profileContainer: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '75%',
  },
  profileContainerMobile: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
  },
  profileHeader: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    marginBottom: '4%',
    paddingTop: '2%',
  },
  profileHeaderMobile: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    marginBottom: '0%',
    paddingTop: '2%',
  },
  profileHeaderNameMobile: {
    color: '#0076BB',
    fontWeight: '700',
    fontSize: '20px',
    textTransform: 'capitalize',
    fontFamily: 'NewOrderBold',
  },
  avatarVerified: {
    borderRadius: '50%',
    overflow: 'hidden',
    marginTop: '15%',
    marginRight: '1%',
    border: 2,
    borderColor: '#0076BB',
    borderStyle: 'solid',
  },
  profileHeaderText: {
    // display: 'inline-flex',
    // position: 'relative',
    // top: '-100px',
    // right: '-49px',
  },
  profileHeaderTextMobile: {
    width: '70%',
    // display: 'inline-flex',
    // position: 'relative',
    // top: '-100px',
    // right: '-49px',
  },
  profileHeaderName: {
    color: '#0076BB',
    fontWeight: '700',
    fontSize: '28px',
    textTransform: 'capitalize',
    fontFamily: 'NewOrderBold',
  },
  bannerDescription: {
    fontWeight: '700',
    fontSize: '22px',
    color: '#000000',
    fontFamily: 'NiveauGroteskRegular',
  },
  bannerDescriptionMobile: {
    fontWeight: '700',
    fontSize: '16px',
    color: '#000000',
    marginBottom: '2%',
    fontFamily: 'NiveauGroteskRegular',
  },
  bannerDescriptionSmall: {
    fontWeight: '400',
    fontSize: '22px',
    color: '#000000',
    fontFamily: 'NiveauGroteskRegular',
  },
  bannerDescriptionSmallMobile: {
    fontWeight: '400',
    fontSize: '16px',
    color: '#000000',
    fontFamily: 'NiveauGroteskRegular',
  },
  links: {
    color: '#0076BB',
    fontWeight: '400',
    fontStyle: 'italic',
    fontSize: '16px',
    float: 'right',
    fontFamily: 'NiveauGroteskRegularItal',
  },
  linksMobile: {
    color: '#0076BB',
    fontWeight: '400',
    fontStyle: 'italic',
    fontSize: '14px',
    float: 'right',
    fontFamily: 'NiveauGroteskRegularItal',
  },
  pofileArrow: {
    display: 'inline-block',
    width: '0px',
    height: '0px',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderLeft: '8px solid #0076BB',
    position: 'relative',
    top: '4px',
    left: '2px',
  },
  dashboardArrow: {
    display: 'inline-block',
    width: '0px',
    height: '0px',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderRight: '8px solid #0076BB',
    position: 'relative',
    left: '-5px',
    fontStyle: 'italic',
  },
};

const DashboardPage = () => {
  const mobile = useIsMobile();
  const tablet = useMediaQuery({ maxWidth: 960 });
  const [focussedEvent] = useState(null);
  const [showMore, setShowmore] = useState(false);
  const [showMoreWallet, setShowMoreWallet] = useState(false);
  const [showMoreCards, setShowMoreCards] = useState(false);
  const [pageNo, setPageNo] = useState(1);

  const client = useApolloClient();
  useQuery(GET_PROFILE_INFO);

  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });

  // const { data, loading, fetchMore } = useQuery(GET_DASHBOARD_INFO, {
  //   variables: {
  //     personId: profileData?.getProfile?.personId,
  //     status: 'TODO',
  //     pageSize,
  //     pageNo: 1,
  //   },
  // });
  const [fetchValue, { data, fetchMore }] = useLazyQuery(GET_DASHBOARD_INFO, {
    variables: {
      personId: profileData?.getProfile?.personId,
      status: 'TODO',
      pageSize,
      pageNo: 1,
    },
  });
  useEffect(() => {
    if (profileData?.getProfile?.personId) {
      fetchValue({
        personId: profileData?.getProfile?.personId,
        status: 'TODO',
        pageSize,
        pageNo: 1,
      });
    }
  }, [profileData]);

  const trackerData = useMemo(
    () => ({
      ...profileData?.getProfile,
    }),
    [profileData?.getProfile],
  );

  const userId = data?.getUserProfile?.profile
    ? data?.getUserProfile?.profile?.personId
    : 0;

  const fetchData = (isPage, setHasMore) => {
    return new Promise((reslove, reject) => {
      setPageNo(isPage);
      fetchMore({
        variables: {
          personId: profileData?.getProfile?.personId,
          status: 'TODO',
          pageSize,
          pageNo: isPage,
        },
        updateQuery: (pre, { fetchMoreResult }) => {
          if (
            pre?.getUserCred.history?.length
            >= fetchMoreResult?.getUserCred?.totalCount
          ) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          return pre?.getUserCred.history?.length
            >= fetchMoreResult?.getUserCred?.totalCount
            ? pre
            : {
                ...pre,
                getUserCred: {
                  ...pre.getUserCred,
                  __typename: pre.getUserCred.__typename,
                  history: [
                    ...pre.getUserCred.history,
                    ...fetchMoreResult.getUserCred.history,
                  ],
                },
              };
        },
      })
        .then(() => {
          reslove();
        })
        .catch(() => {
          reject();
        });
    });
  };

  const setShowMoreClick = val => {
    setShowmore(val);
    fetchData(1);
  };

  const metaTitle = useMemo(() => {
    return focussedEvent
      ? `${strip(focussedEvent.community.name)} ${strip(focussedEvent.name)}`
      : '';
  }, [focussedEvent]);

  const metaDescription = useMemo(() => {
    return focussedEvent
      ? `${
          focussedEvent.summary
            ? strip(focussedEvent.summary)
            : truncate(strip(focussedEvent.description), {
                length: 140,
                separator: ' ',
              })
        } #sponsored`
      : '';
  }, [focussedEvent]);

  const heroAssetUrl = useMemo(
    () => (focussedEvent
        ? get(focussedEvent, 'heroPlaylist.items[0].asset.url')
        : ''),
    [focussedEvent],
  );

  const meta = useMemo(
    () => [
      {
        property: 'og:type',
        content: 'article',
      },
      {
        property: 'og:tag',
        content: 'sponsored',
      },
      {
        property: 'og:title',
        content: metaTitle,
      },
      {
        property: 'og:description',
        content: metaDescription,
      },
      heroAssetUrl
        ? {
            property: 'og:image',
            content: heroAssetUrl,
          }
        : {},
      {
        property: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        property: 'twitter:title',
        content: metaTitle,
      },
      {
        property: 'twitter:description',
        content: metaDescription,
      },
      heroAssetUrl
        ? {
            property: 'twitter:image',
            content: heroAssetUrl,
          }
        : {},
    ],
    [heroAssetUrl, metaDescription, metaTitle],
  );

  const cHeight = useMemo(() => {
    if (mobile) {
      return '100%';
    }
    return tablet ? 'calc(100VW)' : '100%';
  }, [mobile, tablet]);

  return (
    <>
      <LoadBlur>
        <Main meta={meta}>
          {!mobile && (
            <img
              alt='bg1'
              src={rsbg}
              style={{ width: '10%', position: 'absolute', height: '100%' }}
            />
          )}
          {!mobile && (
            <img
              alt='bg1'
              src={rsbg1}
              style={{
                width: '10%',
                position: 'absolute',
                left: tablet ? '85%' : '88%',
                top: '13%',
                height: '100%',
              }}
            />
          )}
          {/* {showPage && ( */}
          <div
            style={{
              backgroundColor: 'white',
              maxWidth: mobile ? 'calc(100VW)' : 'calc(100VW - 50px)',
              height: cHeight,
            }}
          >
            <div
              style={
                mobile ? styles.profileContainerMobile : styles.profileContainer
              }
            >
              {!showMore && !showMoreWallet && !showMoreCards && (
                <div
                  style={
                    mobile || tablet
                      ? styles.profileHeaderMobile
                      : styles.profileHeader
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      width: mobile || tablet ? '100%' : '50%',
                    }}
                  >
                    <div
                      style={{
                        marginRight: '4%',
                        width: 'auto',
                        marginLeft: '2%',
                      }}
                    >
                      <Avatar
                        style={{
                          ...styles.avatarVerified,
                          width: mobile ? 80 : 120,
                          height: mobile ? 80 : 120,
                        }}
                      >
                        <Image
                          style={{
                            height: '100%',
                            zIndex: '9',
                            position: 'relative',
                          }}
                          alt='User headshot'
                          showLoading={false}
                          src={
                            data?.getUserProfile?.profile
                              ? data?.getUserProfile?.profile?.person?.headshot
                              : avatarSource
                          }
                        />
                        <Image
                          style={{
                            position: 'absolute',
                            width: mobile ? '110px' : '165px',
                            height: mobile ? '110px' : '165px',
                          }}
                          src={pfb}
                          alt='pfb'
                        />
                      </Avatar>
                    </div>
                    <div
                      style={
                        mobile || tablet
                          ? styles.profileHeaderTextMobile
                          : styles.profileHeaderText
                      }
                    >
                      <Typography
                        style={
                          mobile
                            ? styles.profileHeaderNameMobile
                            : styles.profileHeaderName
                        }
                      >
                        {data?.getUserProfile?.profile?.person?.firstName}&nbsp;
                        {data?.getUserProfile?.profile?.person?.lastName}
                      </Typography>
                      <Typography
                        style={
                          mobile
                            ? styles.bannerDescriptionMobile
                            : styles.bannerDescription
                        }
                      >
                        Member since{' '}
                        <span style={{ color: '#F48120', fontWeight: 'bold' }}>
                          {data?.getUserProfile?.history?.memberSince}
                        </span>
                      </Typography>
                      <Divider
                        style={{ background: 'black', marginBottom: '2%' }}
                      />
                      <div
                        style={{
                          display: 'block',
                          marginBottom: '2%',
                          width: '140%',
                        }}
                      >
                        <Image
                          style={{
                            width: mobile ? '20px' : '34px',
                            marginRight: '3%',
                          }}
                          src={SmalliconsHP3}
                        />
                        <span
                          color='black'
                          style={
                            mobile
                              ? styles.bannerDescriptionSmallMobile
                              : styles.bannerDescriptionSmall
                          }
                        >
                          <span
                            style={{ color: '#F48120', fontWeight: 'bold' }}
                          >
                            {data?.getUserProfile?.history?.houseParty}
                            &nbsp;&nbsp;
                          </span>
                          House Parties
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'block',
                          marginBottom: '2%',
                          width: '140%',
                        }}
                      >
                        <Image
                          style={{
                            width: mobile ? '20px' : '34px',
                            marginRight: '3%',
                          }}
                          src={SmallIconsCB3}
                        />
                        <span
                          style={
                            mobile
                              ? styles.bannerDescriptionSmallMobile
                              : styles.bannerDescriptionSmall
                          }
                        >
                          <span
                            style={{ color: '#F48120', fontWeight: 'bold' }}
                          >
                            {data?.getUserProfile?.history?.chatterBoxTrials}
                            &nbsp;&nbsp;
                          </span>
                          Chatterboxes
                        </span>
                      </div>
                      <Link
                        style={mobile ? styles.linksMobile : styles.links}
                        to='/profile'
                        onClick={() => {
                          tracker.trackGoogleAnalyticsEvent(
                            'PROFILE_SETTINGS',
                            'PROFILE_SETTINGS',
                            trackerData,
                          );
                        }}
                      >
                        Profile Settings <div style={styles.pofileArrow} />
                      </Link>
                    </div>
                  </div>
                  {!mobile && !tablet && (
                    <div
                      style={{
                        display: 'flex',
                        width: '44%',
                        marginLeft: '2%',
                      }}
                    >
                      <Image
                        style={{ cursor: 'pointer' }}
                        alt='appadd'
                        src={appadd}
                        onClick={() => {
                          const platform = navigator?.userAgentData?.platform
                            || navigator?.platform;
                          if (
                            platform.indexOf('Mac') >= 0
                            || platform === 'iPhone'
                          ) {
                            window.open(
                              APP_STORE_LINK,
                              '_blank',
                            );
                          } else {
                            window.open(
                              PLAY_STORE_LINK,
                              '_blank',
                            );
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
              {!showMore && !showMoreWallet && !showMoreCards && (
                <div style={{ margin: mobile || tablet ? '10px' : '' }}>
                  <CredList
                    noOfActivities={data?.getMyActivity}
                    values={data?.getUserCred}
                    userId={userId}
                    showMore={showMore}
                    fetchNewRecords={fetchData}
                    setShowmore={setShowMoreClick}
                    pageNo={pageNo}
                    trackerData={trackerData}
                  />
                  <DashboardListWalletFadeout />
                  {/* <WalletEntry userId={userId} showMoreWallet={showMoreWallet} updateVallet={updateVallet} showMoreCards={showMoreCards} updateCards={updateCards} /> */}
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {(showMore || showMoreWallet || showMoreCards) && (
                  <Button
                    iconLeft
                    onClick={() => {
                      setShowmore(false);
                      setShowMoreWallet(false);
                      setShowMoreCards(false);
                    }}
                    transparent
                    style={{
                      color: '#0076BB',
                      border: '2px solid #0076BB',
                      borderRadius: 15,
                      margin: 20,
                      width: mobile || tablet ? '46%' : '20%',
                      textTransform: 'capitalize',
                      fontStyle: 'italic',
                    }}
                  >
                    <div style={styles.dashboardArrow} />
                    Back to Dashboard
                  </Button>
                )}
                {(showMoreWallet || showMoreCards) && (
                  <DashboardListWalletFadeout />
                  // <WalletEntry userId={userId} showMoreWallet={showMoreWallet} updateVallet={updateVallet} showMoreCards={showMoreCards} updateCards={updateCards}/>
                )}
                {showMore && (
                  // showPage &&
                  <CredList
                    showAll
                    noOfActivities={data?.getMyActivity}
                    values={data?.getUserCred}
                    userId={userId}
                    showMore={showMore}
                    pageNo={pageNo}
                    fetchNewRecords={fetchData}
                    setShowmore={setShowMoreClick}
                    trackerData={trackerData}
                  />
                )}
              </div>
              {/* {mobile && <DashboardRating />} */}
            </div>
          </div>
          {/* )} */}
        </Main>
      </LoadBlur>
    </>
  );
};

export default DashboardPage;
